const et = {
  brand: "E2 Care",
  tagline: "Rahulik, ühendatud hooldus.",
  nav_dashboard: "Töölaud",
  nav_residents: "Patsiendid",
  nav_patients: "Patsiendid",
  nav_rooms: "Ruumid",
  nav_devices: "Seadmed",
  nav_events: "Sündmused",
  nav_alerts: "Hoiatused",
  nav_users: "Meeskond",
  nav_settings: "Seaded",
  nav_admin: "Haldus",
  nav_signout: "Logi välja",
  topbar_search_placeholder: "Otsi patsiente, ruume, seadmeid…",
  admin_super_only: "Ainult superadministraatorid saavad organisatsioone hallata.",
  admin_admin_only: "Sellele lehele pääsevad ainult administraatorid.",
  admin_tab_orgs: "Organisatsioonid",
  admin_tab_users: "Kasutajad",
  admin_tab_patients: "Patsiendid",
  admin_tab_rooms: "Ruumid",
  admin_tab_buildings: "Hooned",
  admin_tab_devices: "Seadmed",
  admin_tab_alerts: "Häired",
  admin_tab_qa: "Testivahendid",
  admin_delete: "Kustuta",
  admin_no_orgs_yet: "Organisatsioone pole veel.",
  admin_field_name: "Nimi",
  admin_field_email: "E-post",
  admin_field_phone: "Telefon",
  admin_field_password: "Parool",
  admin_field_role: "Roll",
  admin_field_type: "Tüüp",
  admin_field_timezone: "Ajavöönd",
  admin_field_address: "Aadress",
  admin_field_status: "Olek",
  admin_field_organization: "Organisatsioon",
  admin_password_keep: "Jäta tühjaks, et säilitada",
  admin_field_birth_date: "Sünnikuupäev",
  admin_field_room: "Ruum",
  admin_field_room_none: "Määramata",
  admin_field_photo: "Foto URL",
  admin_field_photo_hint: "Kleebi avalik URL — täielik üleslaadimine v2-s.",
  admin_field_notes: "Hooldaja märkmed",
  admin_field_emergency_contact: "Peamine hädaolukorra kontakt",
  admin_field_ec_name: "Nimi",
  admin_field_ec_phone: "Telefon",
  admin_field_ec_relationship: "Suhe",
  admin_field_mac: "MAC-aadress",
  admin_field_firmware: "Püsivara",
  admin_field_assignment: "Määratud",
  admin_field_assigned_room: "Määratud ruum",
  admin_field_assigned_patient: "Määratud patsient",
  admin_field_assigned_hint: "Valikuline. Andurid → ruum; käevõrud → patsient.",
  admin_field_sensor_target: "Paigaldatud",
  admin_field_sensor_target_hint: "Ütleb süsteemile, kas see andur jälgib ust või akent.",
  sensor_target_door: "Uks",
  sensor_target_window: "Aken",
  sensor_target_unset: "Seadistamata",
  admin_field_sensor_label: "Anduri silt",
  admin_field_sensor_label_hint: "Sõbralik nimi, mida kuvatakse häiretes ja sündmustes — nt „Esiuks“, „Vannitoa aken“.",
  admin_field_building: "Hoone",
  admin_field_building_required: "Tuba peab kuuluma hoonesse.",
  room_openings: "Avad",
  room_no_openings: "Sellesse tuppa pole veel ukse- ega aknaandureid paigaldatud.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Viimane muutus",
  admin_field_description: "Kirjeldus",
  admin_field_severity: "Raskusaste",
  admin_field_patient: "Patsient",
  admin_field_device: "Seade",
  admin_field_message: "Sõnum",
  admin_orgs_title: "Organisatsioonid",
  admin_orgs_sub: "Loo, muuda ja arhiveeri E2 Care rentnikke.",
  admin_orgs_count: "organisatsioonid",
  admin_org_new: "Uus organisatsioon",
  admin_org_new_title: "Uus organisatsioon",
  admin_org_edit_title: "Muuda organisatsiooni",
  admin_org_created: "Organisatsioon loodud.",
  admin_org_updated: "Organisatsioon uuendatud.",
  admin_org_deleted: "Organisatsioon arhiveeritud.",
  admin_org_delete_title: "Arhiveerida organisatsioon?",
  admin_org_delete_confirm: "«{name}» peidetakse nimekirjadest.",
  admin_users_title: "Kasutajad",
  admin_users_sub_super: "Halda kõiki kasutajakontosid kõigis rentnikes.",
  admin_users_sub_org: "Halda {org} kasutajakontosid.",
  admin_user_new: "Uus kasutaja",
  admin_user_new_title: "Uus kasutaja",
  admin_user_edit_title: "Muuda kasutajat",
  admin_user_created: "Kasutaja loodud.",
  admin_user_updated: "Kasutaja uuendatud.",
  admin_user_deleted: "Kasutaja arhiveeritud.",
  admin_user_delete_title: "Arhiveerida kasutaja?",
  admin_user_delete_confirm: "«{name}» kaotab juurdepääsu.",
  admin_user_memberships: "Organisatsiooni liikmesused",
  admin_patients_title: "Patsiendid",
  admin_patients_sub_super: "Halda kõiki patsiente kõigis rentnikes.",
  admin_patients_sub_org: "Halda patsiente {org}-s.",
  admin_patient_new: "Uus patsient",
  admin_patient_new_title: "Uus patsient",
  admin_patient_edit_title: "Muuda patsienti",
  admin_patient_created: "Patsient loodud.",
  admin_patient_updated: "Patsient uuendatud.",
  admin_patient_deleted: "Patsient arhiveeritud.",
  admin_patient_delete_title: "Arhiveerida patsient?",
  admin_patient_delete_confirm: "«{name}» peidetakse nimekirjadest.",
  admin_rooms_title: "Ruumid",
  admin_rooms_sub_super: "Seadista ruumid kõigis rentnikes.",
  admin_rooms_sub_org: "Seadista ruumid {org}-s.",
  admin_room_new: "Uus ruum",
  admin_room_new_title: "Uus ruum",
  admin_room_edit_title: "Muuda ruumi",
  admin_room_created: "Ruum loodud.",
  admin_room_updated: "Ruum uuendatud.",
  admin_room_deleted: "Ruum arhiveeritud.",
  admin_room_delete_title: "Arhiveerida ruum?",
  admin_room_delete_confirm: "«{name}» peidetakse.",
  admin_devices_title: "Seadmed",
  admin_devices_sub_super: "Varusta Moko seadmeid kõigis rentnikes.",
  admin_devices_sub_org: "Varusta Moko seadmeid {org}-s.",
  admin_device_new: "Uus seade",
  admin_device_new_title: "Uus seade",
  admin_device_edit_title: "Muuda seadet",
  admin_device_created: "Seade loodud.",
  admin_device_updated: "Seade uuendatud.",
  admin_device_deleted: "Seade arhiveeritud.",
  admin_device_delete_title: "Arhiveerida seade?",
  admin_device_delete_confirm: "Seade {mac} peidetakse.",
  admin_buildings_title: "Hooned",
  admin_buildings_sub_super: "Grupeeri ruumid hoonete / tiibade kaupa kõigis rentnikes.",
  admin_buildings_sub_org: "Grupeeri ruumid hoonete / tiibade kaupa {org}-s.",
  admin_building_new: "Uus hoone",
  admin_building_new_title: "Uus hoone",
  admin_building_edit_title: "Muuda hoonet",
  admin_building_created: "Hoone loodud.",
  admin_building_updated: "Hoone uuendatud.",
  admin_building_deleted: "Hoone arhiveeritud.",
  admin_building_delete_title: "Arhiveerida hoone?",
  admin_building_delete_confirm: "«{name}» peidetakse.",
  admin_qa_title: "Testivahendid",
  admin_qa_sub: "Süsti sündmusi / hoiatusi, et testida ilma reaalse Moko riistvarata.",
  admin_qa_event_title: "Süsti testsündmus",
  admin_qa_event_sub: "Simuleerib Moko webhooki.",
  admin_qa_alert_title: "Süsti testhoiatus",
  admin_qa_alert_sub: "Jätab sündmuste kihi vahele ja kirjutab hoiatuse otse.",
  admin_qa_inject_event: "Süsti sündmus",
  admin_qa_inject_alert: "Süsti hoiatus",
  admin_qa_event_done: "Sündmus süstitud.",
  admin_qa_alert_done: "Hoiatus süstitud.",
  admin_qa_disclaimer: "Need lõpp-punktid tuleb tootmises keelata.",
  admin_alerts_title: "Häirete poliitika",
  admin_alerts_sub: "Kogu {org} häirereeglid. Rakenduvad selle rentniku igale patsiendile.",
  admin_alerts_quiet_title: "Vaiksed tunnid",
  admin_alerts_quiet_desc: "Määrake, millal see organisatsioon on „öörežiimis“. Kasulik mittekriitiliste häirete vaiksemaks suunamiseks.",
  admin_alerts_quiet_hint: "Kellaajad tõlgendatakse organisatsiooni kohalikus ajavööndis. Vahemik võib ületada südaööd (nt 22:00 → 06:00).",
  admin_alerts_night_start: "Öö algab",
  admin_alerts_night_end: "Öö lõpeb",
  admin_alerts_load_failed: "Laadi häirete poliitika",
  admin_alerts_save_failed: "Salvesta häirete poliitika",
  admin_alerts_saved: "Häirete poliitika salvestatud.",
  admin_alerts_clear_title: "Tühjenda aktiivsed häired",
  admin_alerts_clear_desc: "Kinnita kõik selle organisatsiooni avatud häired ühe klõpsuga.",
  admin_alerts_clear_hint: "Kasulik pärast plaanitud õppust või valesti seadistatud andurit, mis tekitas valehäirete laine. Kinnitatud häired jäävad ajalukku.",
  admin_alerts_ack_all_button: "Kinnita kõik",
  admin_alerts_ack_all_title: "Kinnita kõik aktiivsed häired?",
  admin_alerts_ack_all_confirm: "See märgib kinnitatuks iga avatud häire organisatsioonis {org}. Seda toimingut ei saa tagasi võtta.",
  admin_alerts_ack_all_done: "{count} häire(t) kinnitatud.",
  admin_alerts_ack_all_done_generic: "Kõik aktiivsed häired kinnitatud.",
  admin_alerts_ack_all_failed: "Kinnita kõik häired",
  org_type_nursing_home: "Hooldekodu",
  org_type_assisted_living: "Toetatud elamine",
  org_type_hospital: "Haigla",
  org_type_home_care: "Koduhooldus",
  role_admin: "Administraator",
  role_caregiver: "Hooldaja",
  role_family: "Perekond",
  status_active: "aktiivne",
  status_inactive: "mitteaktiivne",
  confirm: "Kinnita",
  sign_in: "Logi sisse",
  sign_up: "Registreeru",
  email: "E-post",
  password: "Parool",
  full_name: "Täisnimi",
  create_account: "Loo konto",
  no_account: "Kontot veel pole?",
  have_account: "Kas teil on juba konto?",
  login_welcome: "Tere tulemast tagasi",
  login_sub: "Logi sisse, et jätkata elanike jälgimist.",
  register_welcome: "Liitu E2 Care-ga",
  register_sub: "Loo oma tööruum vähem kui minutiga.",
  total_residents: "Patsiendid",
  active_devices: "Aktiivsed seadmed",
  open_alerts: "Avatud hoiatused",
  offline_gateways: "Võrguühenduseta seadmed",
  falls_7d: "Kukkumised (7p)",
  sos_7d: "SOS (7p)",
  low_battery: "Madal aku",
  critical_residents: "Kriitilised",
  status_ok: "Kõik korras",
  status_warning: "Tähelepanu",
  status_critical: "Kriitiline",
  status_online: "Võrgus",
  status_offline: "Võrguühenduseta",
  search: "Otsi",
  filter: "Filtreeri",
  all: "Kõik",
  refresh: "Värskenda",
  loading: "Laadimine…",
  no_results: "Siin pole veel midagi.",
  view_profile: "Vaata profiili",
  showing_n_of_m: "Kuvatakse {n} / {m}",
  load_more: "Lae rohkem",
  auto_refresh: "Otseülekanne · automaatne värskendamine",
  auto_refresh_paused: "Peatatud (lae rohkem aktiivne)",
  updated_just_now: "Värskendatud just",
  updated_n_sec_ago: "Värskendatud {n}s tagasi",
  updated_n_min_ago: "Värskendatud {n}m tagasi",
  acknowledge: "Kinnita",
  acknowledged: "Kinnitatud",
  ack_all: "Kinnita kõik",
  ack_all_confirm: "Kinnita kõik {count} aktiivset häiret?",
  ack_all_running: "Kinnitamine…",
  ack_all_done: "{count} häire(t) kinnitatud.",
  ack_all_partial: "{ok} kinnitatud · {fail} ebaõnnestus.",
  last_seen: "Viimati nähtud",
  battery: "Aku",
  signal: "Signaal",
  firmware: "Püsivara",
  room: "Krt / Tuba",
  age: "Vanus",
  emergency_contact: "Hädaolukorra kontakt",
  notes: "Märkmed",
  assigned_devices: "Määratud seadmed",
  recent_events: "Hiljutised sündmused",
  timeline_24h: "Viimased 24 tundi",
  delivery_status: "Tarne olek",
  acknowledged_by: "Kinnitanud",
  dashboard_title: "Ülevaade",
  dashboard_sub: "Kiire ülevaade kõigest, mis toimub kodudes, mida hooldate.",
  residents_title: "Patsiendid",
  residents_sub: "Inimesed, keda praegu jälgite.",
  devices_title: "Seadmed",
  devices_sub: "Andurid ja käevõrud.",
  devices_sub_admin: "Lüüsid, andurid ja käevõrud.",
  events_title: "Otsesündmused",
  events_sub: "Kronoloogiline voog igast ühendatud seadmest.",
  alerts_title: "Hoiatused",
  alerts_sub: "Perele ja hooldajatele edastatud teated.",
  settings_title: "Seaded",
  settings_sub: "Teie eelistused ja teavitusreeglid.",
  users_title: "Meeskond",
  users_sub: "Juurdepääsuga hooldajad, perekond ja administraatorid.",
  falls_chart_title: "Kukkumised & SOS — viimased 7 päeva",
  recent_alerts_title: "Hiljutised kriitilised hoiatused",
  no_alerts: "Avatud hoiatusi pole. Kõik on turvalised.",
  event_fall: "Tuvastatud kukkumine",
  event_sos: "SOS-nuppu vajutatud",
  event_door_open: "Uks avatud",
  event_door_close: "Uks suletud",
  event_inactivity: "Pikaajaline tegevusetus",
  event_low_battery: "Madal aku",
  event_offline: "Seade võrguühenduseta",
  event_online: "Seade taas võrgus",
  event_heartbeat: "Südamelöök",
  event_button_press: "Nuppu vajutatud",
  device_gateway: "Bluetooth-lüüs",
  device_door_sensor: "Ukseandur",
  device_bracelet: "Käevõru",
  device_unknown: "Tundmatu seade",
  language: "Keel",
  notifications: "Teavitused",
  quiet_hours: "Vaiksed tunnid",
  escalation: "Eskaleerimise poliitika",
  just_now: "just nüüd",
  min_ago: "min",
  h_ago: "t",
  d_ago: "p",
  demo_hint: "Demokonto: admin@e2care.lv / Care2024!",
  open_menu: "Ava menüü",
  close_menu: "Sulge menüü",
  care_team: "Hooldusmeeskond",
  family_members: "Perekond",
  no_caregivers: "Hooldajaid pole veel määratud.",
  no_family: "Pereliikmeid pole veel lisatud.",
  add_caregiver: "Lisa hooldaja",
  add_family: "Lisa pereliige",
  select_user: "Vali kasutaja…",
  cancel: "Tühista",
  add: "Lisa",
  remove: "Eemalda",
  save: "Salvesta",
  relationship: "Suhe",
  relationship_son: "Poeg",
  relationship_daughter: "Tütar",
  relationship_spouse: "Abikaasa",
  relationship_other: "Muu",
  notify_via: "Teavita kanali kaudu",
  call_contact: "Helista",
  view_resident: "Ava profiil",
  address: "Aadress",
  admin_only_section: "Administraatori tööriistad",
  rooms_title: "Ruumid",
  rooms_sub: "Iga ruum, mida jälgite — patsiendid, seadmed ja praegune olek.",
  room_name: "Ruum",
  room_type: "Tüüp",
  room_type_private_room: "Privaattuba",
  room_type_shared_room: "Jagatud tuba",
  room_type_apartment: "Korter",
  room_type_corridor: "Koridor",
  room_type_common_area: "Üldkasutatav ala",
  room_floor: "Korrus",
  room_state: "Praegune olek",
  door: "Uks",
  window: "Aken",
  door_open_state: "Avatud",
  door_closed_state: "Suletud",
  door_unknown_state: "Tundmatu",
  room_no_devices: "Selles ruumis pole veel seadmeid.",
  room_no_patients: "Sellele ruumile pole veel patsiente määratud.",
  room_patients: "Patsiendid ruumis",
  room_devices: "Seadmed ruumis",
  room_activity: "Tegevuse ajatelg",
  rooms_filter_all_types: "Kõik tüübid",
  widget_active_alerts: "Aktiivsed hoiatused",
  widget_active_alerts_sub: "Kriitilised, lahendamata ja kinnitatud",
  widget_patients_status: "Patsientide olek",
  widget_devices_health: "Seadmete tervis",
  widget_room_activity: "Ruumide tegevus",
  widget_recent_events: "Otseste sündmuste voog",
  widget_connectivity: "Ühenduvus",
  metric_critical: "Kriitiline",
  metric_unresolved: "Lahendamata",
  metric_acknowledged_count: "Kinnitatud",
  metric_total: "Kokku",
  metric_active: "Aktiivsed",
  metric_online: "Võrgus",
  metric_offline: "Võrguühenduseta",
  metric_ota_pending: "OTA ootel",
  metric_battery_warn: "Madal aku",
  metric_doors_open: "Avatud uksed",
  metric_windows_open: "Avatud aknad",
  metric_signal_avg: "Keskm. signaal",
  metric_last_comm: "Viim. side",
  metric_packets: "Pakette / h",
  view_all: "Vaata kõiki",
  status_new: "Uus",
  status_acknowledged: "Kinnitatud",
  status_resolved: "Lahendatud",
  status_resolved_local: "Lahendatud (kohalik)",
  resolve: "Lahenda",
  add_note: "Lisa märkus",
  save_note: "Salvesta märkus",
  resolve_local_badge: "ainult see seade",
  resolve_local_hint: "Märgib häire lahendatuks ainult teie brauseris. Server ja teised meeskonnaliikmed näevad seda endiselt avatuna.",
  note_placeholder: "Lisa konteksti meeskonnale…",
  notes_count: "{n} märkust",
  device_detail: "Seadme detail",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Püsivara ajalugu",
  device_ota_config: "OTA konfiguratsioon",
  device_ota_status: "OTA olek",
  device_signal: "Signaali kvaliteet",
  device_mac: "MAC-aadress",
  device_serial: "Seerianumber",
  fall_sensitivity: "Kukkumistundlikkus",
  transmission_interval: "Edastusintervall",
  low_battery_threshold: "Madala aku lävi",
  ota_idle: "Jõude",
  ota_pending: "Ootel",
  ota_deploying: "Juurutamine",
  ota_failed: "Ebaõnnestus",
  events_filter_severity: "Raskusaste",
  events_filter_room: "Ruum",
  events_filter_patient: "Patsient",
  events_filter_device: "Seade",
  severity_info: "Info",
  severity_warning: "Hoiatus",
  severity_critical: "Kriitiline",
  telegram_title: "Telegrami hoiatused",
  telegram_desc: "Saa Telegrami hoiatusi teile määratud elanike kohta.",
  telegram_connect: "Ühenda Telegram",
  telegram_connected: "Telegram ühendatud",
  telegram_connected_as: "Telegramiga ühendatud kui {name}",
  telegram_connect_success: "Telegram edukalt ühendatud",
  telegram_connect_error: "Telegrami ühendamine ebaõnnestus. Proovige uuesti.",
  telegram_missing_bot: "Telegrami bot pole seadistatud. Määrake REACT_APP_TELEGRAM_BOT env-failis.",
  telegram_disconnect: "Ühenda lahti",
  telegram_disconnect_success: "Telegram lahti ühendatud.",
  telegram_disconnect_error: "Telegrami lahtiühendamine ebaõnnestus. Proovige uuesti.",
  telegram_already_linked: "See Telegrami konto on juba seotud teise e2-care kasutajaga.",
  telegram_switch_q: "Kasutada teist Telegrami kontot?",
  telegram_switch_intro: "Telegram mäletab kõigil veebisaitidel, milline konto on sisse logitud. Teise kasutamiseks:",
  telegram_switch_step1: "Avage Telegram Web ja logige praegusest kontost välja.",
  telegram_switch_step2: "Naaske siia ja laadige allolev nupp uuesti, seejärel logige sisse teise kontoga.",
  telegram_open_web: "Ava Telegram Web",
  telegram_reload_widget: "Logisin välja — laadi nupp uuesti",
  lang_autodetected_toast: "Tuvastatud keel: {language}. Saate seda muuta seadetes.",
  admin_view_active: "Aktiivsed",
  admin_view_archived: "Arhiveeritud",
  admin_restore: "Taasta",
  admin_restored: "Taastatud.",
  admin_hard_delete: "Kustuta jäädavalt",
  admin_hard_delete_title: "Kustuta jäädavalt?",
  admin_hard_delete_confirm: "«{name}» eemaldatakse jäädavalt andmebaasist. Seda tegevust ei saa tagasi võtta.",
  admin_hard_deleted: "Jäädavalt kustutatud.",
  admin_no_archived: "Arhiveeritud üksusi pole.",
  language_desc: "Kasutatakse rakenduse liidese ning teie Telegrami + push-teavituste jaoks.",
  language_saved: "Keel uuendatud.",
  language_error: "Keelt ei õnnestunud uuendada. Palun proovige uuesti.",
  admin_field_language: "Keel",
  edit: "Muuda",
  generic_error: "Midagi läks valesti. Palun proovige uuesti.",
  caregiver_added: "Hooldaja lisatud.",
  caregiver_removed: "Hooldaja eemaldatud.",
  family_added: "Pereliige lisatud.",
  family_removed: "Pereliige eemaldatud.",
  menu: "Menüü",
  dl_companion_app: "Kaaslasrakendus",
  dl_hero_title: "E2 Care Androidile",
  dl_hero_sub: "Paigaldage kaaslasrakendus Moko-toega telefoni, et edastada häireid, seadistada seadmeid ja püsida ühenduses oma hooldusmeeskonnaga — isegi kui töölaud on suletud.",
  dl_android_apk: "Androidi APK",
  dl_version_loading: "versiooni laadimine…",
  dl_released: "Avaldatud {date}",
  dl_download_apk: "Laadi APK alla",
  dl_unavailable: "Pole saadaval",
  dl_preparing: "Ettevalmistamine…",
  dl_manifest_error: "Manifesti ei õnnestunud laadida. Proovige värskendada — kui probleem püsib, võib ehitusserver olla ümberpaigutamisel.",
  dl_whats_new: "Mis on uut",
  dl_installing_title: "Paigaldamine telefoni",
  dl_step1: "Puudutage ülal „Laadi APK alla“. Teie brauser võib hoiatada, et APK-failid võivad seadet kahjustada — see hoiatus on tavaline iga väljaspool Play Store’i alla laaditud installeri puhul.",
  dl_step2: "Avage allalaaditud fail. Android palub esimesel korral lubada installimist sellest brauserist — lülitage luba sisse ja tulge tagasi.",
  dl_step3: "Puudutage „Installi“ ja seejärel lõpetamisel „Ava“.",
  dl_step4: "Logige sisse oma E2 Care mandaatidega.",
  dl_iphone_note: "iPhone’i versioon tuleb hiljem. Praegu kasutage veebitöölauda.",
  dl_back_to_dashboard: "Tagasi töölauale",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Organisatsiooni muutmine tühjendab praeguse toa ja patsiendi määrangu.",
  admin_view_full: "Täisnimekiri",
  device_filter_assignment: "Määrang",
  device_filter_patient: "Määratud patsiendile",
  device_filter_room: "Määratud toale",
  device_filter_unassigned: "Määramata",
  admin_all_orgs: "Kõik organisatsioonid",
  pagination_prev: "Eelmine",
  pagination_next: "Järgmine",
  pagination_per_page: "Lehe kohta",
  pagination_page_of: "Lehekülg {page} / {pages}",
  pagination_total: "Kokku {total}",
};
export default et;
